// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

// Define a service using a base URL and expected endpoints
export const chatService = createApi({
  reducerPath: 'chatService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['CHAT_USERS'],
  endpoints: ({ query, mutation }) => ({
    getChatHistory: query({
      query: ({ roomId, page = 0, limit = 20 }) => {
        return {
          url: `/chat-service/v1/operator/chat/history/${roomId}`,
          params: {
            page,
            limit,
          },
        };
      },
    }),
    getDisputeChatHistory: query({
      query: ({ roomId, page = 0, limit = 20 }) => {
        return {
          url: `/chat-service/v1/operator/chat/history/${roomId}`,
          params: {
            page,
            limit,
          },
        };
      },
    }),

    getAllUserInChat: query({
      query: ({ search, status, page = 0, limit = 20 }: { search?: string; status?: string; page?: number | string; limit?: number } = {}) => {
        const params: Record<string, any> = {
          page,
          limit,
        };

        if (search && search.trim()) {
          params.search = search.trim();
        }

        if (status && status.toUpperCase() !== 'ALL') {
          params.status = status;
        }

        return {
          url: '/chat-service/v1/operator/chat',
          params,
        };
      },
      providesTags: ['CHAT_USERS'],
    }),

    cancelFriendlyStage: mutation({
      query: (body: { disputeId: string }) => ({
        url: `/jobs/v1/job-disputes-operator/${body.disputeId}/cancel-friendly-stage`,
        method: 'PUT',
        headers: { activeProfile: '1' },
      }),
      invalidatesTags: ['CHAT_USERS'],
    }),

    uploadChatDocuments: mutation<
      { payload: { id: string }[] },
      { formData: FormData; roomId?: string } | FormData
    >({
      query: (arg) => {
        const isFormData = arg instanceof FormData;
        const body = isFormData ? arg : arg.formData;
        const roomId = !isFormData ? arg.roomId : undefined;
        return {
          url: '/chat-service/v1/chat/documents',
          method: 'POST',
          headers: {
            'ACCEPT-CONTENT-TYPE': 'string',
          },
          params: roomId ? { roomId } : undefined,
          body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetChatHistoryQuery,
  useGetAllUserInChatQuery,
  useCancelFriendlyStageMutation,
  useGetDisputeChatHistoryQuery,
  useUploadChatDocumentsMutation,
} = chatService;
